<script>
  import { mouse } from '../state/uiState';

  export let width = 300;
  let windowWidth = 0;

  $: halfWidth = (width + 20) / 2;
  $: y = $mouse.y;
  $: x =
    $mouse.x - halfWidth < 0
      ? halfWidth
      : $mouse.x + halfWidth > windowWidth
      ? windowWidth - halfWidth
      : $mouse.x;
</script>

<svelte:window bind:innerWidth={windowWidth} />
<div
  style={`
    position: absolute; 
    z-index: 99999; 
    top: ${y}px; 
    left: ${x}px; 
    pointer-events:none'`}>
  <div
    className="tooltip"
    style={`
      position:absolute;
      top:5px;
      padding:10px; 
      background:#fff; 
      box-shadow:rgba(0,0,0, .2) 0px 0px 10px;
      transform: translate(-50%,20px);`}>
    <slot />
  </div>
</div>
